import React, { useCallback, useContext, useEffect, useState } from "react";
import getConfigurationService, { Configuration } from "../services/configurationService";

const ConfigContext = React.createContext<Configuration>({} as Configuration);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState<Configuration>({} as Configuration);

    const getConfig = useCallback(() => {
        getConfigurationService().then(res => {
            setConfig(res)
        })
    }, [getConfigurationService])

    useEffect(getConfig, [getConfig]);

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    )
}

export default ConfigContext;

export const useConfig = (): Configuration => useContext(ConfigContext);